import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useReschedule = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, scheduledAt }: { id: string; scheduledAt: string }) =>
      api.drafts.reschedule(id, scheduledAt),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["drafts"] });
      qc.invalidateQueries({ queryKey: ["scheduled"] });
      qc.invalidateQueries({ queryKey: ["published"] });
    },
  });
};
